const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const isDev = import.meta.env.VITE_STAGE === 'dev';
const UPLOADS = isDev ? `${API_BASE_URL}/uploads` : import.meta.env.VITE_UPLOADS;

export const getUploadsBase = () => UPLOADS;

export const getUserAvatarUrl = (user: any, full?: boolean): string | null => {
    if (user?.avatar) {
        // Already a full URL (e.g. from InvitePersonsModal) — return as-is
        if (typeof user.avatar === 'string' && user.avatar.startsWith('http')) return user.avatar;
        const prefix = full ? '' : 'w200-';
        return `${UPLOADS}/users/${prefix}${user.avatar}`;
    }
    return user?.avatarUrl || user?.photo?.url || null;
};

export const getUserCoverUrl = (user: any, full?: boolean): string | null => {
    if (!user?.headingImage) return null;
    if (typeof user.headingImage === 'string' && user.headingImage.startsWith('http')) return user.headingImage;
    const prefix = full ? '' : 'w1024-';
    return `${UPLOADS}/users/${prefix}${user.headingImage}`;
};

export const getTeamImage = (fileName: string, size?: string | null): string => {
    

    // Uprav velikost obrázku
    const imageSize = size ? `${size}-` : 'w75-';


    if (!fileName) return `${UPLOADS}/teams/${imageSize}default-team-logo.png`;

    if(fileName === 'free-agent') {
        const imagePath = `${UPLOADS}/teams/${imageSize}default-team-logo.png`;
        return imagePath;
    }

    // Formátuj název týmu pro cestu k obrázku
    //const formattedName = teamName.toLowerCase().replace(/\s+/g, '-');

    // Cesta k obrázku
    const imagePath = `${UPLOADS}/teams/${imageSize}${fileName}`;

   ////console.log('imagePath......:', imagePath);

    // Vzhledem k tomu, že obrázky jsou ve složce public, Vite je neoptimalizuje během buildu.
    return imagePath;
};




export const getLeagueImage = (fileName: string, size?: string | null): string => {
    

    // Uprav velikost obrázku
    const imageSize = size ? `${size}-` : 'h75-';


    if (!fileName) return `${UPLOADS}/leagues/${imageSize}default.png`;

    if(fileName === 'free-agent') {
        const imagePath = `${UPLOADS}/leagues/${imageSize}default.png`;
        return imagePath;
    }

    // Formátuj název týmu pro cestu k obrázku
    //const formattedName = teamName.toLowerCase().replace(/\s+/g, '-');

    // Cesta k obrázku
    const imagePath = `${UPLOADS}/leagues/${imageSize}${fileName}`;

   ////console.log('imagePath......:', imagePath);

    // Vzhledem k tomu, že obrázky jsou ve složce public, Vite je neoptimalizuje během buildu.
    return imagePath;
};




export const getDressImage = (raw: string) => {
    if (!raw || raw === 'hockeybook-home') return '/img/rosters/mh-white-dress.png'
    if (raw === 'hockeybook-away') return '/img/rosters/mh-blue-dress.png'
    const imagePath = `/img/rosters/${raw}-dress.png`;
    return imagePath;
};

export const getRosterImage = (raw: string) => {
    const imagePath = `/img/rosters/${raw}.jpg`;
    return imagePath;
};


